import { fetchApi } from "./apiCalls"

export const getCicloInscripcion = async(props) => {
    const { url, headers } = props;
    const response = await fetchApi({
        url: `${url}/utils/busquedas`,
        headers: headers,
        content: {
          opcion: "CICLO_INS",
        },
    })
    return response[0].IdCiclo
  }

  export function listaCiclos (ciclo) {
    const inicio = 2022
    let arr = []
    for(let i = inicio;i<= ciclo;i++){
        arr.push(i)
    }
    return arr.join().replaceAll(',', ' - ')
}